
import * as React from 'react';

import { connect } from 'react-redux';

import { assign as _assign } from 'lodash';

import {
  RegisterUserDataModel,
  GlobalState,
  formatMessage,
  CreateFormProps,
} from 'src/api';

import {
  createForm,
  FormValues
} from 'src/api/models/Form/Form';

import {
  registerUserDataFormValues,
} from 'src/api/models/Registration/user-data/user-data.class';

import { requestAPIActions, RequestApiHttpPayload} from 'loopback-react-request';

import './RegisterUserDataForm.scss';
import { LogoCentered } from '../../Images';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './RegisterUserDataForm.messages';
import { LogoutButton } from '../Logout/LogoutButton';

export const RegisterUserTestForm = () => {
  return (
    <div className="partial-register-form d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 p-5">
          <div className="col-12">
            <LogoCentered />
            <h5 className="border-bottom pb-3 mb-3">
              <FormattedMessage {...MESSAGES.registerUserDataFormHeadline} />
            </h5>
            <RegisterUserDataConnected />
            <div className="meta d-flex mt-2">
              <div className="col-8 text-center">
                <p className="small">
                    <LogoutButton buttonMessage={MESSAGES.registerUserDataFormLogoutLink} />  
                </p>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

const createRegisterUserForm = createForm<RegisterUserDataModel, CreateFormProps<RegisterUserDataModel>>({
  className: 'row m-0',
  dispatchData: (dispatch, values, state) => {
    
    if (state) {
      const { userData } = state;
      if (userData && userData.result && values) {
        (values as FormValues<RegisterUserDataModel & {userId: string}>).userId = userData.result.userId;
        dispatch(requestAPIActions.load<RequestApiHttpPayload>(
          'userData', {
            url: `/UserData/${userData.result.id}`,
            options: {
              method: 'PUT',
              data: values,
            },
          },
          true
        ));
      }
    }
  },
  formFields: registerUserDataFormValues(),
  preSubmit: (values, state) => _assign({}, values, {
    validated: true,
    lang: state && state.localize.language.selected || 'en-150',
  }),
  shouldRedirect: true,
  stateKeys: 'userData',
  submitButton: {
    text: formatMessage({...MESSAGES.registerUserDataFormButton}),
    className: 'register-button mt-4'
  }
})();

const RegisterUserDataConnected = connect((state: GlobalState) => ({state}))(createRegisterUserForm);